// Leyendas de retención de archivos. Regla (spec 2026-06-11): evidencias
// se eliminan 18 meses tras subirse; ZIPs 12 meses tras el cierre del caso.
// El registro en el caso SIEMPRE se conserva.

export type LeyendaRetencion = {
  texto: string;
  /** true cuando faltan <30 días — la UI lo pinta en ámbar */
  urgente: boolean;
};

export function leyendaEliminacion(
  expiraAt: string,
  ahora: Date = new Date(),
): LeyendaRetencion {
  const dias = Math.floor(
    (new Date(expiraAt).getTime() - ahora.getTime()) / 86_400_000,
  );
  if (dias <= 0) return { texto: "Se elimina hoy", urgente: true };
  if (dias < 60) {
    return {
      texto: `Se elimina en ${dias} día${dias === 1 ? "" : "s"}`,
      urgente: dias < 30,
    };
  }
  return { texto: `Se elimina en ${Math.floor(dias / 30)} meses`, urgente: false };
}
